import { Navigate, Route, Routes } from 'react-router-dom'

import { links, paths } from 'apps'
import { CommonLayout } from 'layouts'
import { PrivateRoute, PublicRoute } from 'routes'
import { useAppSelector } from 'hooks'
import { RaceDetail, RaceMain, RaceOpen, RaceResult, RaceScheduledRaces } from './pages'

const tabs = [
  {
    name: 'open',
    link: links.race.open()
  },
  {
    name: 'scheduled race',
    link: links.race.scheduledRaces()
  },
  {
    name: 'result',
    link: links.race.result()
  }
]
function Race() {
  const auth = useAppSelector(state => state.auth)

  return (
    <Routes>
      <Route
        path={paths.default()}
        element={
          <PrivateRoute isLogged={auth.isLogged} layout={CommonLayout} navigate={links.home.index()}>
            <RaceMain titleTabs={tabs} />
          </PrivateRoute>
        }
      >
        <Route path={paths.race.open()} element={<RaceOpen />} />
        <Route path={paths.race.scheduledRaces()} element={<RaceScheduledRaces />} />
        <Route path={paths.race.result()} element={<RaceResult />} />
        <Route path='*' element={<Navigate replace to={paths.notFound.feature()} />} />
      </Route>
      <Route
        path={paths.race.detail()}
        element={
          <PublicRoute layout={CommonLayout}>
            <RaceDetail />
          </PublicRoute>
        }
      />
      <Route path='*' element={<Navigate replace to={paths.notFound.feature()} />} />
    </Routes>
  )
}

export default Race
